import { atom } from 'jotai';
import { WalletDetails } from '../typings/wallet';
import { createRequestAtom } from '../utils/request-atom';

export const walletDetailsAtom = createRequestAtom<WalletDetails | undefined>(undefined);

export const walletModalOpenAtom = atom(false);
